/* Space theme — vanilla JS, no dependencies. */
(() => {
  'use strict';

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const S = window.Space || { routes: {}, strings: {} };
  const t = (k) => (S.strings && S.strings[k]) || '';

  const formatMoney = (cents, format) => {
    const f = format || S.moneyFormat || '${{amount}}';
    const fix = (n, d = 2, th = ',', dec = '.') => {
      const v = (n / 100).toFixed(d).split('.');
      return v[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${th}`) + (v[1] ? dec + v[1] : '');
    };
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount': return fix(cents);
        case 'amount_no_decimals': return fix(cents, 0);
        case 'amount_with_comma_separator': return fix(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fix(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fix(cents, 2, "'", '.');
        default: return fix(cents);
      }
    });
  };

  let toastTimer;
  const toast = (msg) => {
    let el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    requestAnimationFrame(() => el.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  };

  /* Drawers ---------------------------------------------------------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    const focusable = $('input, button, a', $('.drawer__panel', d));
    setTimeout(() => (id === 'search-drawer' ? $('input[type=search]', d) : focusable)?.focus(), 60);
  };
  const closeDrawers = () => {
    $$('.drawer[aria-hidden="false"]').forEach((d) => d.setAttribute('aria-hidden', 'true'));
    document.body.classList.remove('is-locked');
    lastFocus?.focus?.();
  };

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-open]');
    if (open) {
      e.preventDefault();
      openDrawer(open.dataset.open);
      return;
    }
    if (e.target.closest('[data-close]')) {
      closeDrawers();
      return;
    }
    const cartLink = e.target.closest('[data-cart-link]');
    if (cartLink && S.cartDrawer && $('#cart-drawer')) {
      e.preventDefault();
      openDrawer('cart-drawer');
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawers();
  });

  /* Cart -------------------------------------------------------------- */
  const cartJson = (url, body) =>
    fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(async (r) => {
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || t('error'));
      return data;
    });

  const refreshCart = async (cart) => {
    cart = cart || (await cartJson('/cart.js'));
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.dataset.count = cart.item_count;
    });
    $$('[data-drawer-count]').forEach((el) => (el.textContent = `(${cart.item_count})`));

    const drawer = $('#cart-drawer');
    const page = $('[data-cart-page]');
    const ids = [];
    if (drawer) ids.push('cart-drawer');
    const res = ids.length ? await fetch(`${window.location.pathname}?sections=${ids.join(',')}`).then((r) => r.json()) : {};
    if (drawer && res['cart-drawer']) {
      const doc = new DOMParser().parseFromString(res['cart-drawer'], 'text/html');
      const next = $('[data-cart-body]', doc);
      if (next) $('[data-cart-body]', drawer).innerHTML = next.innerHTML;
    }
    if (page) {
      const html = await fetch(`${S.routes.cart}`).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const next = $('[data-cart-page]', doc);
      if (next) page.innerHTML = next.innerHTML;
    }
    syncGift();
    return cart;
  };

  /* Free gift: add the gift line when the bar says the spend is reached, remove it when it isn't. */
  let giftBusy = false;
  const syncGift = async () => {
    const bar = $('[data-gift-bar][data-gift-variant]');
    if (!bar || giftBusy) return;
    const qualifies = bar.dataset.giftQualifies === 'true';
    const inCart = bar.dataset.giftInCart === 'true';
    if (qualifies === inCart) return;
    giftBusy = true;
    try {
      if (qualifies) {
        await cartJson(S.routes.cartAdd, { items: [{ id: +bar.dataset.giftVariant, quantity: 1, properties: { _free_gift: 'true' } }] });
      } else {
        const cart = await cartJson('/cart.js');
        const idx = cart.items.findIndex((i) => i.properties && i.properties._free_gift);
        if (idx > -1) await cartJson(S.routes.cartChange, { line: idx + 1, quantity: 0 });
      }
      giftBusy = false;
      await refreshCart();
    } catch {
      giftBusy = false;
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGift);
  else syncGift();

  const changeLine = async (line, quantity) => {
    try {
      const cart = await cartJson(S.routes.cartChange, { line, quantity });
      await refreshCart(cart);
    } catch (err) {
      toast(err.message || t('error'));
      refreshCart();
    }
  };

  document.addEventListener('click', (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    if (qtyBtn) {
      const line = +qtyBtn.dataset.line;
      const input = $(`[data-line-qty="${line}"]`, qtyBtn.closest('.line'));
      const next = Math.max(0, (+input.value || 0) + +qtyBtn.dataset.qtyChange);
      input.value = next;
      changeLine(line, next);
      return;
    }
    const rm = e.target.closest('[data-remove]');
    if (rm) changeLine(+rm.dataset.remove, 0);
  });
  document.addEventListener('click', async (e) => {
    const add = e.target.closest('[data-upsell-add]');
    if (!add) return;
    add.disabled = true;
    try {
      await cartJson(S.routes.cartAdd, { items: [{ id: +add.dataset.upsellAdd, quantity: 1 }] });
      await refreshCart();
    } catch (err) {
      add.disabled = false;
      toast(err.message || t('error'));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (input) changeLine(+input.dataset.lineQty, Math.max(0, +input.value || 0));
  });
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    const code = form.elements.discount.value.trim();
    if (!code) return;
    try {
      await fetch(`/discount/${encodeURIComponent(code)}`, { redirect: 'manual' });
      await refreshCart();
      toast(t('added') ? 'Code applied' : 'Code applied');
    } catch {
      toast(t('error'));
    }
  });

  /* Product gallery + lightbox ---------------------------------------- */
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));
  const initGallery = (g) => {
    const track = $('[data-gallery-track]', g);
    if (!track || g.goToId) return;
    const slides = $$('.gallery__slide', track);
    const thumbs = $$('[data-thumb]', g);
    const prev = $('[data-gallery-prev]', g);
    const next = $('[data-gallery-next]', g);
    const cur = $('[data-gallery-current]', g);
    let index = 0;

    const setActive = (i) => {
      index = i;
      const id = slides[i] && slides[i].dataset.slide;
      thumbs.forEach((b) => b.setAttribute('aria-current', String(b.dataset.thumb === id)));
      if (cur) cur.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
      slides.forEach((s, n) => n !== i && $('video', s)?.pause());
    };
    const goTo = (i, smooth = true) => {
      i = clamp(i, 0, slides.length - 1);
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      setActive(i);
    };
    const indexOf = (id) => slides.findIndex((s) => s.dataset.slide === String(id));
    g.goToId = (id, smooth = true) => {
      const i = indexOf(id);
      if (i > -1) goTo(i, smooth);
    };

    let st;
    track.addEventListener('scroll', () => {
      clearTimeout(st);
      st = setTimeout(() => setActive(clamp(Math.round(track.scrollLeft / track.clientWidth), 0, slides.length - 1)), 60);
    }, { passive: true });
    prev?.addEventListener('click', () => goTo(index - 1));
    next?.addEventListener('click', () => goTo(index + 1));
    thumbs.forEach((b) => b.addEventListener('click', () => g.goToId(b.dataset.thumb)));
    const start = indexOf(g.dataset.start);
    requestAnimationFrame(() => goTo(start > -1 ? start : 0, false));
    window.addEventListener('resize', () => goTo(index, false));

    const lb = $('[data-lightbox]', g);
    if (!lb || typeof lb.showModal !== 'function') return;
    const lbTrack = $('[data-lightbox-track]', lb);
    const lbSlides = $$('[data-lb-slide]', lb);
    const lbCur = $('[data-lb-current]', lb);
    const lbPrev = $('[data-lb-prev]', lb);
    const lbNext = $('[data-lb-next]', lb);
    let li = 0;

    const unzoom = () => {
      lb.classList.remove('is-zoomed');
      lbSlides.forEach((s) => {
        s.classList.remove('is-zoomed');
        $('img', s).style.transformOrigin = '';
        $('img', s).style.removeProperty('--px');
        $('img', s).style.removeProperty('--py');
      });
    };
    const lbSet = (i) => {
      li = i;
      if (lbCur) lbCur.textContent = i + 1;
      if (lbPrev) lbPrev.disabled = i === 0;
      if (lbNext) lbNext.disabled = i === lbSlides.length - 1;
    };
    const lbGo = (i, smooth = true) => {
      unzoom();
      i = clamp(i, 0, lbSlides.length - 1);
      lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
      lbSet(i);
    };
    const open = (id) => {
      const target = id || (slides[index] && slides[index].dataset.slide);
      let i = lbSlides.findIndex((s) => s.dataset.lbSlide === String(target));
      if (i < 0) i = 0;
      lbSlides.forEach((s) => ($('img', s).loading = 'eager'));
      lb.showModal();
      document.body.classList.add('is-locked');
      requestAnimationFrame(() => lbGo(i, false));
    };

    g.addEventListener('click', (e) => {
      const opener = e.target.closest('[data-lightbox-open]');
      if (opener && !lb.contains(opener)) {
        e.preventDefault();
        open(opener.dataset.lightboxOpen);
      }
    });
    $('[data-lightbox-close]', lb)?.addEventListener('click', () => lb.close());
    lbPrev?.addEventListener('click', () => lbGo(li - 1));
    lbNext?.addEventListener('click', () => lbGo(li + 1));
    lb.addEventListener('close', () => {
      unzoom();
      document.body.classList.remove('is-locked');
      const id = lbSlides[li] && lbSlides[li].dataset.lbSlide;
      if (id) g.goToId(id, false);
    });
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') lbGo(li + 1);
      if (e.key === 'ArrowLeft') lbGo(li - 1);
    });
    let lt;
    lbTrack.addEventListener('scroll', () => {
      clearTimeout(lt);
      lt = setTimeout(() => {
        const i = clamp(Math.round(lbTrack.scrollLeft / lbTrack.clientWidth), 0, lbSlides.length - 1);
        if (i !== li) {
          unzoom();
          lbSet(i);
        }
      }, 80);
    }, { passive: true });

    const setOrigin = (img, e) => {
      const r = img.getBoundingClientRect();
      const x = clamp(((e.clientX - r.left) / r.width) * 100, 0, 100);
      const y = clamp(((e.clientY - r.top) / r.height) * 100, 0, 100);
      img.style.transformOrigin = `${x}% ${y}%`;
    };
    const pan = (img, x, y) => {
      img.style.setProperty('--px', `${x}px`);
      img.style.setProperty('--py', `${y}px`);
    };
    lbSlides.forEach((s) => {
      const img = $('img', s);
      let drag = null;
      let px = 0;
      let py = 0;
      s.addEventListener('click', (e) => {
        if (s._moved) { s._moved = false; return; }
        if (e.target !== img) {
          if (!s.classList.contains('is-zoomed')) lb.close();
          else unzoom();
          return;
        }
        const zoomed = !s.classList.contains('is-zoomed');
        px = 0; py = 0; pan(img, 0, 0);
        if (zoomed) setOrigin(img, e);
        s.classList.toggle('is-zoomed', zoomed);
        lb.classList.toggle('is-zoomed', zoomed);
      });
      s.addEventListener('pointerdown', (e) => {
        if (!s.classList.contains('is-zoomed')) return;
        drag = { x: e.clientX, y: e.clientY, px, py };
        s._moved = false;
        img.classList.add('is-dragging');
        s.setPointerCapture(e.pointerId);
      });
      s.addEventListener('pointermove', (e) => {
        if (!drag) return;
        const dx = e.clientX - drag.x;
        const dy = e.clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 4) s._moved = true;
        const r = s.getBoundingClientRect();
        px = clamp(drag.px + dx, -r.width, r.width);
        py = clamp(drag.py + dy, -r.height, r.height);
        pan(img, px, py);
      });
      const end = () => {
        drag = null;
        img.classList.remove('is-dragging');
      };
      s.addEventListener('pointerup', end);
      s.addEventListener('pointercancel', end);
      s.addEventListener('wheel', (e) => {
        if (!s.classList.contains('is-zoomed')) return;
        e.preventDefault();
        px = clamp(px - e.deltaX, -s.clientWidth, s.clientWidth);
        py = clamp(py - e.deltaY, -s.clientHeight, s.clientHeight);
        pan(img, px, py);
      }, { passive: false });
    });
  };
  $$('[data-gallery]').forEach(initGallery);

  /* Product form ------------------------------------------------------ */
  class ProductForm extends HTMLElement {
    connectedCallback() {
      try {
        this.product = JSON.parse($('[data-product-json]', this).textContent);
      } catch {
        return;
      }
      this.form = $('[data-product-form]', this);
      this.idField = $('[data-variant-id]', this);
      this.atc = $('[data-atc]', this);
      this.atcLabel = $('[data-atc-label]', this);
      this.errorEl = $('[data-error]', this);
      this.memberPct = parseFloat(this.dataset.memberPct) || 0;
      this.moneyFormat = this.dataset.moneyFormat;

      this.addEventListener('change', (e) => {
        if (e.target.matches('[data-option-value]')) this.onOption();
      });
      this.form.addEventListener('submit', (e) => this.submit(e));
      $$('[data-pdp-qty]', this).forEach((b) =>
        b.addEventListener('click', () => {
          const input = $('[data-pdp-qty-input]', this);
          input.value = Math.max(1, (+input.value || 1) + +b.dataset.pdpQty);
        })
      );
      const stickyBtn = $('[data-sticky-atc]', this);
      stickyBtn?.addEventListener('click', () => this.form.requestSubmit());
      const sticky = $('[data-sticky]', this);
      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(([en]) => sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0), { threshold: 0 }).observe(this.atc);
      }
      this.sortSizes();
      this.markUnavailable();
    }

    // Sizes in a sensible order whatever order the variants were created in: numbers first, then XS to 3XL
    sortSizes() {
      const ladder = ['xxs', 'xs', 's', 'm', 'l', 'xl', '2xl', 'xxl', '3xl', 'xxxl'];
      const rank = (v) => {
        if (/^\d+(\.\d+)?$/.test(v)) return parseFloat(v);
        const i = ladder.indexOf(v.toLowerCase());
        return i < 0 ? 1000 : 100 + i;
      };
      $$('fieldset[data-option-index]', this).forEach((fs) => {
        if (!/^size/i.test($('legend', fs).textContent.trim())) return;
        const box = $('.opts', fs);
        const pairs = $$('input', box).map((i) => [i, i.nextElementSibling]);
        pairs.sort((a, b) => rank(a[0].value) - rank(b[0].value));
        pairs.forEach(([i, l]) => { box.appendChild(i); box.appendChild(l); });
      });
    }

    selectedOptions() {
      const out = [];
      $$('fieldset[data-option-index]', this).forEach((fs) => {
        const checked = $('input:checked', fs);
        out[+fs.dataset.optionIndex] = checked ? checked.value : null;
      });
      return out;
    }

    variantFor(options) {
      return this.product.variants.find((v) => v.options.every((o, i) => o === options[i]));
    }

    markUnavailable() {
      const sel = this.selectedOptions();
      $$('fieldset[data-option-index]', this).forEach((fs) => {
        const idx = +fs.dataset.optionIndex;
        $$('input', fs).forEach((input) => {
          // Judge each value only against the options chosen before it, so "Men's" is not struck out just because Kids / 10 is selected
          const matches = this.product.variants.filter((v) => v.options[idx] === input.value && sel.slice(0, idx).every((o, k) => v.options[k] === o));
          const exists = matches.length > 0;
          input.classList.toggle('is-unavailable', !matches.some((v) => v.available));
          const label = input.nextElementSibling;
          input.hidden = !exists;
          if (label && label.tagName === 'LABEL') label.hidden = !exists;
        });
      });
    }

    // After an earlier option changes, move later options to the nearest value that exists
    settleOptions() {
      const fieldsets = $$('fieldset[data-option-index]', this);
      for (let i = 1; i < fieldsets.length; i++) {
        const sel = this.selectedOptions();
        if (this.variantFor(sel)) continue;
        const prefix = sel.slice(0, i);
        const pick = this.product.variants.filter((v) => prefix.every((o, k) => v.options[k] === o)).sort((a, b) => b.available - a.available)[0];
        if (!pick) continue;
        $$('input', fieldsets[i]).forEach((input) => (input.checked = input.value === pick.options[i]));
      }
    }

    onOption() {
      this.settleOptions();
      const sel = this.selectedOptions();
      $$('[data-option-label]', this).forEach((el) => (el.textContent = sel[+el.dataset.optionLabel] || ''));
      const v = this.variantFor(sel);
      this.markUnavailable();
      this.update(v);
    }

    update(v) {
      const pricePerks = (price, compare) => {
        const priceEl = $('[data-price]', this);
        const was = $('[data-price-was]', this);
        const now = $('[data-price-now]', this);
        const badge = $('[data-sale-badge]', this);
        const onSale = compare > price;
        priceEl.classList.toggle('price--sale', onSale);
        now.textContent = formatMoney(price, this.moneyFormat);
        if (was) {
          was.textContent = onSale ? formatMoney(compare, this.moneyFormat) : '';
          was.hidden = !onSale;
        } else if (onSale) {
          const s = document.createElement('s');
          s.className = 'price__was';
          s.dataset.priceWas = '';
          s.textContent = formatMoney(compare, this.moneyFormat);
          priceEl.prepend(s);
        }
        if (badge) badge.hidden = !onSale;
        const member = $('[data-member-price]', this);
        if (member) {
          const show = this.memberPct > 0 && !onSale;
          member.hidden = !show;
          if (show) {
            $('[data-member-was]', member).textContent = formatMoney(price, this.moneyFormat);
            $('[data-member-now]', member).textContent = formatMoney(Math.round((price * (100 - this.memberPct)) / 100), this.moneyFormat);
          }
        }
      };

      if (!v) {
        this.atc.disabled = true;
        const sb = $('[data-sticky-atc]', this);
        if (sb) sb.disabled = true;
        this.atcLabel.textContent = t('unavailable');
        return;
      }
      this.idField.value = v.id;
      pricePerks(v.price, v.compare_at_price || 0);
      this.atc.disabled = !v.available;
      this.atcLabel.textContent = v.available ? t('add') : t('soldOut');
      const sp = $('[data-sticky-price]', this);
      if (sp) sp.textContent = formatMoney(v.price, this.moneyFormat);
      const sb = $('[data-sticky-atc]', this);
      if (sb) sb.disabled = !v.available;
      if (v.featured_media) this.showMedia(String(v.featured_media.id));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url);
    }

    showMedia(id) {
      const g = $('[data-gallery]', this);
      if (g && g.goToId) g.goToId(id);
    }

    async submit(e) {
      e.preventDefault();
      if (this.atc.disabled) return;
      this.errorEl.textContent = '';
      this.atc.disabled = true;
      this.atcLabel.textContent = t('adding');
      try {
        const fd = new FormData(this.form);
        const body = { items: [{ id: +fd.get('id'), quantity: +fd.get('quantity') || 1 }] };
        await cartJson(S.routes.cartAdd, body);
        const cart = await refreshCart();
        if (S.cartDrawer && $('#cart-drawer')) openDrawer('cart-drawer');
        else toast(t('added'));
        void cart;
      } catch (err) {
        this.errorEl.textContent = err.message || t('error');
      } finally {
        this.atcLabel.textContent = t('add');
        this.atc.disabled = false;
      }
    }
  }
  if (!customElements.get('product-form')) customElements.define('product-form', ProductForm);

  /* Collection filters ---------------------------------------------- */
  // Inputs live outside their <form> (form="…" attribute), so listen at document level.
  let facetTimer;
  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!el.matches('[data-auto-submit]') || !el.form) return;
    clearTimeout(facetTimer);
    facetTimer = setTimeout(() => el.form.submit(), el.type === 'number' ? 600 : 200);
  });
  // Filter dropdowns: one open at a time, close on outside click / Escape.
  const fdrops = $$('[data-fdrop]');
  if (fdrops.length) {
    fdrops.forEach((d) =>
      d.addEventListener('toggle', () => {
        if (d.open) fdrops.forEach((o) => o !== d && (o.open = false));
      })
    );
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-fdrop]')) fdrops.forEach((d) => (d.open = false));
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') fdrops.forEach((d) => (d.open = false));
    });
  }

  /* FAQ search: hide questions (and empty topics) that don't match ------- */
  $$('[data-faq]').forEach((faq) => {
    const input = $('[data-faq-search]', faq);
    if (!input) return;
    const items = $$('[data-faq-item]', faq);
    const groups = $$('[data-faq-group]', faq);
    const none = $('[data-faq-none]', faq);
    input.addEventListener('input', () => {
      const q = input.value.trim().toLowerCase();
      let shown = 0;
      items.forEach((it) => {
        const hit = !q || it.textContent.toLowerCase().includes(q);
        it.hidden = !hit;
        if (q && hit) it.open = true;
        if (hit) shown += 1;
      });
      groups.forEach((g) => (g.hidden = !$$('[data-faq-item]', g).some((it) => !it.hidden)));
      if (none) none.hidden = shown > 0;
    });
  });

  /* Horizontal rails (showcase) ---------------------------------------- */
  $$('[data-rail]').forEach((rail) => {
    const track = $('[data-rail-track]', rail);
    const prev = $('[data-rail-prev]', rail);
    const next = $('[data-rail-next]', rail);
    if (!track || !prev || !next) return;
    const sync = () => {
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth > track.scrollWidth - 8;
    };
    const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* Predictive search ------------------------------------------------- */
  const pInput = $('[data-predictive-input]');
  const pOut = $('[data-predictive-results]');
  if (pInput && pOut && S.routes.predictive) {
    let timer;
    let controller;
    pInput.addEventListener('input', () => {
      clearTimeout(timer);
      const q = pInput.value.trim();
      if (q.length < 2) {
        pOut.innerHTML = '';
        return;
      }
      timer = setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        try {
          const url = `${S.routes.predictive}?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[limit]=6&resources[type]=product,page,article`;
          const res = await fetch(url, { signal: controller.signal });
          const html = await res.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const body = $('[data-predictive-body]', doc);
          pOut.innerHTML = body ? body.innerHTML : '';
        } catch (err) {
          if (err.name !== 'AbortError') pOut.innerHTML = '';
        }
      }, 220);
    });
  }

  /* Related products ---------------------------------------------------- */
  const recs = $('[data-recs-url]');
  if (recs) {
    fetch(recs.dataset.recsUrl)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sec = $('.section', doc);
        if (sec) recs.before(sec);
      })
      .catch(() => {});
  }

  /* Sale countdown ------------------------------------------------------ */
  const initSale = (root) => {
    if (root._saleTimer) clearInterval(root._saleTimer);
    const parse = (v) => {
      const m = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec((v || '').trim());
      return m ? Date.parse(`${m[1]}-${m[2]}-${m[3]}T${m[4]}:${m[5]}:00${root.dataset.tz || '+13:00'}`) : NaN;
    };
    const start = parse(root.dataset.start);
    const end = parse(root.dataset.end);
    const editing = !!(window.Shopify && window.Shopify.designMode);
    root.classList.toggle('is-editing', editing);
    const nodes = {};
    $$('[data-unit]', root).forEach((n) => (nodes[n.dataset.unit] = n));
    const fmt = new Intl.DateTimeFormat('en-NZ', { timeZone: 'Pacific/Auckland', weekday: 'short', day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true });
    const dates = $('[data-sale-dates]', root);
    if (dates && !isNaN(start) && !isNaN(end)) {
      dates.textContent = `${fmt.format(start)} to ${fmt.format(end)} (NZ time)`;
    }
    const set = (node, text, animate) => {
      if (node.textContent === text) return;
      if (!animate || matchMedia('(prefers-reduced-motion: reduce)').matches || node.textContent === '--') {
        node.textContent = text;
        return;
      }
      node.classList.remove('is-in');
      node.classList.add('is-out');
      setTimeout(() => {
        node.textContent = text;
        node.classList.remove('is-out');
        node.classList.add('is-in');
      }, 200);
    };
    const tick = () => {
      if (!root.isConnected) return clearInterval(root._saleTimer);
      const now = Date.now();
      let phase = 'upcoming';
      let target = start;
      if (isNaN(start) || isNaN(end)) {
        phase = 'ended';
        target = now;
      } else if (now >= end) {
        phase = 'ended';
        target = end;
      } else if (now >= start) {
        phase = 'live';
        target = end;
      }
      if (root.dataset.phase !== phase) root.dataset.phase = phase;
      let left = Math.max(0, target - now);
      [['days', 86400000], ['hours', 3600000], ['minutes', 60000], ['seconds', 1000]].forEach(([u, size]) => {
        const v = Math.floor(left / size);
        left -= v * size;
        if (nodes[u]) set(nodes[u], v < 10 ? `0${v}` : String(v), root.dataset.phase !== '' && phase !== 'ended');
      });
    };
    tick();
    root._saleTimer = setInterval(tick, 250);
  };
  /* Free gift countdown on the product page */
  const initGiftTimer = (box) => {
    const end = +box.dataset.endTs * 1000;
    const out = $('[data-gift-time]', box);
    if (!end || !out) return;
    const pad = (n) => (n < 10 ? `0${n}` : String(n));
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        box.hidden = true;
        return clearInterval(box._giftTimer);
      }
      const d = Math.floor(left / 86400000);
      const h = Math.floor((left % 86400000) / 3600000);
      const m = Math.floor((left % 3600000) / 60000);
      const s = Math.floor((left % 60000) / 1000);
      out.textContent = `${d > 0 ? `${d}d ` : ''}${pad(h)}h ${pad(m)}m ${pad(s)}s`;
    };
    tick();
    box._giftTimer = setInterval(tick, 1000);
  };
  $$('[data-gift-countdown]').forEach(initGiftTimer);

  $$('[data-sale]').forEach(initSale);
  document.addEventListener('shopify:section:load', (e) => $$('[data-sale]', e.target).forEach(initSale));

  /* Scroll reveal ------------------------------------------------------- */
  const reveal = $$('[data-reveal]');
  if (reveal.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver(
      (entries) =>
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        }),
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    reveal.forEach((el) => io.observe(el));
  } else {
    reveal.forEach((el) => el.classList.add('is-in'));
  }
})();
